import { Component, input, output } from '@angular/core';
import { BaseControlComponent } from '../base-control/base-control.component';
import { AppModule } from '../../../../modules/app.module';
import { ZorroModule } from '../../../../modules/zorro.module';
import { ThirdPartyModule } from '../../../../modules/third-party.module';
import { AngularModule } from '../../../../modules/angular.module';
import { FieldLabelComponent } from '../../../ui/forms/field-label/field-label.component';
import { FieldErrorComponent } from '../../../ui/forms/field-error/field-error.component';

export interface SearchableDropdownOption {
	value: string | number;
	label: string;
}

@Component({
	selector: 'app-searchable-dropdown-control',
	standalone: true,
	imports: [AppModule, ZorroModule, ThirdPartyModule, AngularModule, FieldLabelComponent, FieldErrorComponent],
	templateUrl: './searchable-dropdown-control.component.html',
	styleUrls: ['./searchable-dropdown-control.component.scss'],
})
export class SearchableDropdownControlComponent extends BaseControlComponent {
	public options = input<SearchableDropdownOption[]>([]);
	public loading = input<boolean>(false);
	public onSearchEmitter = output<string>({ alias: 'onSearch' });

	public onSearch(term: string): void {
		this.onSearchEmitter.emit(term);
	}
}
